'use strict';

const WRAP_SELECTOR = '.pcard__image-wrap[data-photo-array], .product-list-card__image-wrap[data-photo-array]';
const MAIN_IMG_SELECTOR = '.pcard__img-placeholder, .pcard__img, .product-list-card__img';

const initCardSwipers = () => {
    document.querySelectorAll(WRAP_SELECTOR).forEach(wrap => {
        if (wrap._cardSwiperInit) return;
        wrap._cardSwiperInit = true;

        const urls = wrap.dataset.photoArray.split(';').filter(Boolean);
        if (urls.length < 2) return;

        let built = false;
        let swiperEl = null;
        let slides = [];
        let dots = [];
        let activeIndex = 0;

        const build = () => {
            if (built) return;
            built = true;

            // Preload images
            urls.forEach(url => { new Image().src = url; });

            swiperEl = document.createElement('div');
            swiperEl.className = 'pcard__swiper';

            const mainImg = wrap.querySelector(MAIN_IMG_SELECTOR);

            urls.forEach((url, i) => {
                const img = document.createElement('img');
                img.src = url;
                img.alt = mainImg?.alt ?? '';
                img.className = 'pcard__swiper-img';
                img.style.display = i === 0 ? '' : 'none';
                swiperEl.appendChild(img);
                slides.push(img);
            });

            // Dots
            const dotsWrap = document.createElement('div');
            dotsWrap.className = 'pcard__swiper-dots';
            urls.forEach((_, i) => {
                const dot = document.createElement('span');
                dot.className = 'pcard__swiper-dot' + (i === 0 ? ' is-active' : '');
                dotsWrap.appendChild(dot);
                dots.push(dot);
            });
            swiperEl.appendChild(dotsWrap);

            wrap.appendChild(swiperEl);
        };

        const showSlide = (idx) => {
            if (idx === activeIndex) return;
            slides[activeIndex].style.display = 'none';
            dots[activeIndex].classList.remove('is-active');
            activeIndex = idx;
            slides[activeIndex].style.display = '';
            dots[activeIndex].classList.add('is-active');
        };

        const activate = () => {
            build();
            const mainImg = wrap.querySelector(MAIN_IMG_SELECTOR);
            if (mainImg) mainImg.style.visibility = 'hidden';
            swiperEl.style.display = '';
        };

        const deactivate = () => {
            if (!built) return;
            swiperEl.style.display = 'none';
            showSlide(0);
            const mainImg = wrap.querySelector(MAIN_IMG_SELECTOR);
            if (mainImg) mainImg.style.visibility = '';
        };

        // Desktop: hover
        wrap.addEventListener('mouseenter', activate);

        wrap.addEventListener('mousemove', (e) => {
            if (!built) return;
            const rect = wrap.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const idx = Math.min(Math.floor(x / rect.width * urls.length), urls.length - 1);
            showSlide(idx);
        });

        wrap.addEventListener('mouseleave', deactivate);

        // Click: dots switch slide, image navigates to product
        wrap.addEventListener('click', (e) => {
            if (!built) return;
            const dot = e.target.closest('.pcard__swiper-dot');
            if (dot) {
                e.preventDefault();
                e.stopPropagation();
                const idx = dots.indexOf(dot);
                if (idx >= 0) showSlide(idx);
                return;
            }
            if (e.target.closest('.pcard__swiper-img')) {
                const link = wrap.querySelector('a.pcard__image-link');
                if (link) link.click();
            }
        });

    });
};

window.initCardSwipers = initCardSwipers;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardSwipers);
} else {
    initCardSwipers();
}
